import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { PRACTICE_AREAS } from '../mock/data';

const PracticeAreas = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState('immigration');

  return (
    <section id="practice" className="section relative" style={{ background: 'linear-gradient(180deg, #0A0E1A 0%, #0c1220 50%, #0A0E1A 100%)' }}>
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <div className="label-small mb-4">{t.practice.label}</div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-[#F0EDE8] leading-[1.05]">
            {t.practice.heading}
          </h2>
          <div className="gold-rule mt-6 mb-6" />
          <p className="text-[#DCCFAD] text-lg italic font-heading">
            {t.practice.subheading}
          </p>
        </motion.div>

        <div className="mt-14 border-t border-[rgba(196,163,90,0.2)]">
          {PRACTICE_AREAS.map((area, idx) => {
            const isOpen = open === area.id;
            return (
              <motion.div
                key={area.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.6, delay: idx * 0.08 }}
                className="border-b border-[rgba(196,163,90,0.2)]"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : area.id)}
                  className="w-full flex items-center justify-between py-7 text-left group"
                >
                  <div className="flex items-start gap-6 flex-1 min-w-0">
                    <div className="font-heading text-[#C4A35A] text-sm tracking-[0.2em] pt-2 w-10 flex-shrink-0">
                      {String(idx + 1).padStart(2, '0')}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-[10px] tracking-[0.4em] text-[#8a7a54] uppercase mb-1">
                        {area.tier}
                      </div>
                      <h3 className="font-heading text-2xl md:text-4xl text-[#F0EDE8] group-hover:text-[#C4A35A] transition-colors">
                        {area.title}
                      </h3>
                      <p className="font-heading italic text-[#8a7a54] text-sm md:text-base mt-1">
                        {area.tagline}
                      </p>
                    </div>
                  </div>
                  <div className="ml-4 flex-shrink-0 w-10 h-10 rounded-full border border-[rgba(196,163,90,0.3)] flex items-center justify-center text-[#C4A35A] group-hover:border-[#C4A35A] group-hover:bg-[rgba(196,163,90,0.08)] transition-all">
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </div>
                </button>

                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                      style={{ overflow: 'hidden' }}
                    >
                      <div className="pl-16 pr-2 pb-8">
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-3">
                          {area.items.map((item, i) => (
                            <li key={i} className="flex items-start gap-3 text-[#DCCFAD] text-[15px]">
                              <span className="text-[#C4A35A] mt-2 flex-shrink-0">
                                <span style={{ display: 'inline-block', width: 6, height: 1, background: '#C4A35A' }} />
                              </span>
                              <span>{item}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;
